var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-box__change-used-btn"},[_c('button',{staticClass:"btn-multi btn-multi--single",on:{"click":_vm.clickButton}},[_c('span',{staticClass:"btn-multi-checkmark"},[_vm._v("\n      利用済みにする\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }